/** Shared chrome: actions, field labels, placeholders. */
const dictionary = {
  "en": {
    "actions": {
      "save": "Save changes",
      "saveShort": "Save",
      "cancel": "Cancel",
      "add": "Add",
      "next": "Next",
      "previous": "Previous",
      "back": "Back",
      "skip": "Skip",
      "finish": "Finish",
      "invite": "Invite",
      "confirm": "Confirm",
      "delete": "Delete",
      "copy": "Copy",
      "submit": "Submit",
      "verify": "Verify",
      "reset": "Reset",
      "close": "Close",
      "edit": "Edit",
      "search": "Search",
      "showMore": "Show more",
      "showLess": "Show less",
      "watchDemo": "Watch demo video"
    },
    "fields": {
      "email": "Email",
      "emailAddress": "Email address",
      "workEmail": "Work email",
      "password": "Password",
      "repeatPassword": "Repeat password",
      "firstName": "First name",
      "lastName": "Last name",
      "fullName": "Full name",
      "companyName": "Company name",
      "phoneNumber": "Phone number",
      "businessType": "Business type",
      "employeeCount": "Employee number"
    },
    "placeholders": {
      "startTyping": "Start typing...",
      "selectTeamSize": "Select team size",
      "selectIndustry": "Select industry",
      "search": "Search...",
      "enterEmail": "Enter Email...",
      "enterCurrentPassword": "Enter Current Password...",
      "enterNewPassword": "Enter New Password...",
      "confirmPassword": "Confirm Password...",
      "enterCode": "Enter the code here...",
      "searchTeamMemberEmail": "Search team member by email",
      "selectBusinessType": "Select business type",
      "selectCompanySize": "Select number of employees"
    },
    "labels": {
      "from": "From",
      "to": "To",
      "name": "Name",
      "role": "Role",
      "actions": "Actions",
      "groups": "Groups",
      "language": "Language",
      "off": "OFF",
      "on": "ON",
      "optional": "Optional",
      "search": "search",
      "success": "Success",
      "loading": "Loading..."
    },
    "scale": {
      "low": "Low",
      "average": "Average",
      "high": "High",
      "howToLead": "How to lead",
      "howToDevelop": "How to develop",
      "howToManage": "How to manage",
      "watchOut": "WATCH OUT"
    },
    "verifiedByAon": "Verified by AON online assessments",
    "orSignInWith": "Or sign in with",
    "invalidField": "Invalid field",
    "comingSoonAlt": "page is under construction and coming soon",
    "employeeSizes": [
      "1-10",
      "11-50",
      "51-150",
      "151- 300",
      "300-1000",
      "1001+"
    ]
  },
  "de": {
    "actions": {
      "save": "Änderungen speichern",
      "saveShort": "Speichern",
      "cancel": "Abbrechen",
      "add": "Hinzufügen",
      "next": "Weiter",
      "previous": "Zurück",
      "back": "Zurück",
      "skip": "Überspringen",
      "finish": "Abschließen",
      "invite": "Einladen",
      "confirm": "Bestätigen",
      "delete": "Löschen",
      "copy": "Kopieren",
      "submit": "Absenden",
      "verify": "Prüfen",
      "reset": "Zurücksetzen",
      "close": "Schließen",
      "edit": "Bearbeiten",
      "search": "Suchen",
      "showMore": "Mehr anzeigen",
      "showLess": "Weniger anzeigen",
      "watchDemo": "Demo-Video ansehen"
    },
    "fields": {
      "email": "E-Mail",
      "emailAddress": "E-Mail-Adresse",
      "workEmail": "Geschäftliche E-Mail",
      "password": "Passwort",
      "repeatPassword": "Passwort wiederholen",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "fullName": "Vollständiger Name",
      "companyName": "Unternehmensname",
      "phoneNumber": "Telefonnummer",
      "businessType": "Branche",
      "employeeCount": "Anzahl der Mitarbeitenden"
    },
    "placeholders": {
      "startTyping": "Tippen Sie hier...",
      "selectTeamSize": "Teamgröße wählen",
      "selectIndustry": "Branche wählen",
      "search": "Suchen...",
      "enterEmail": "E-Mail eingeben...",
      "enterCurrentPassword": "Aktuelles Passwort eingeben...",
      "enterNewPassword": "Neues Passwort eingeben...",
      "confirmPassword": "Passwort bestätigen...",
      "enterCode": "Code hier eingeben...",
      "searchTeamMemberEmail": "Teammitglied nach E-Mail suchen",
      "selectBusinessType": "Branche wählen",
      "selectCompanySize": "Anzahl der Mitarbeitenden wählen"
    },
    "labels": {
      "from": "Von",
      "to": "Bis",
      "name": "Name",
      "role": "Rolle",
      "actions": "Aktionen",
      "groups": "Gruppen",
      "language": "Sprache",
      "off": "AUS",
      "on": "AN",
      "optional": "Optional",
      "search": "suchen",
      "success": "Erfolg",
      "loading": "Wird geladen..."
    },
    "scale": {
      "low": "Niedrig",
      "average": "Durchschnitt",
      "high": "Hoch",
      "howToLead": "Führen",
      "howToDevelop": "Entwickeln",
      "howToManage": "Führen",
      "watchOut": "ACHTUNG"
    },
    "verifiedByAon": "Verifiziert durch AON-Online-Assessments",
    "orSignInWith": "Oder anmelden mit",
    "invalidField": "Ungültiges Feld",
    "comingSoonAlt": "Seite befindet sich im Aufbau und kommt bald",
    "employeeSizes": [
      "1-10",
      "11-50",
      "51-150",
      "151- 300",
      "300-1000",
      "1001+"
    ]
  },
  "fi": {
    "actions": {
      "save": "Tallenna muutokset",
      "saveShort": "Tallenna",
      "cancel": "Peruuta",
      "add": "Lisää",
      "next": "Seuraava",
      "previous": "Edellinen",
      "back": "Takaisin",
      "skip": "Ohita",
      "finish": "Valmis",
      "invite": "Kutsu",
      "confirm": "Vahvista",
      "delete": "Poista",
      "copy": "Kopioi",
      "submit": "Lähetä",
      "verify": "Vahvista",
      "reset": "Nollaa",
      "close": "Sulje",
      "edit": "Muokkaa",
      "search": "Hae",
      "showMore": "Näytä lisää",
      "showLess": "Näytä vähemmän",
      "watchDemo": "Katso esittelyvideo"
    },
    "fields": {
      "email": "Sähköposti",
      "emailAddress": "Sähköpostiosoite",
      "workEmail": "Työsähköposti",
      "password": "Salasana",
      "repeatPassword": "Toista salasana",
      "firstName": "Etunimi",
      "lastName": "Sukunimi",
      "fullName": "Koko nimi",
      "companyName": "Yrityksen nimi",
      "phoneNumber": "Puhelinnumero",
      "businessType": "Liiketoimintatyyppi",
      "employeeCount": "Henkilöstömäärä"
    },
    "placeholders": {
      "startTyping": "Ala kirjoittaa...",
      "selectTeamSize": "Valitse tiimin koko",
      "selectIndustry": "Valitse toimiala",
      "search": "Hae...",
      "enterEmail": "Anna sähköpostiosoite...",
      "enterCurrentPassword": "Anna nykyinen salasana...",
      "enterNewPassword": "Anna uusi salasana...",
      "confirmPassword": "Vahvista salasana...",
      "enterCode": "Syötä koodi tähän...",
      "searchTeamMemberEmail": "Hae tiimin jäsentä sähköpostiosoitteella",
      "selectBusinessType": "Valitse liiketoimintatyyppi",
      "selectCompanySize": "Valitse työntekijöiden määrä"
    },
    "labels": {
      "from": "Alkaen",
      "to": "Päättyen",
      "name": "Nimi",
      "role": "Rooli",
      "actions": "Toiminnot",
      "groups": "Ryhmät",
      "language": "Kieli",
      "off": "POIS",
      "on": "PÄÄLLÄ",
      "optional": "Valinnainen",
      "search": "hae",
      "success": "Onnistui",
      "loading": "Ladataan..."
    },
    "scale": {
      "low": "Matala",
      "average": "Keskiarvo",
      "high": "Korkea",
      "howToLead": "Johtamisvinkit",
      "howToDevelop": "Kehittymisvinkit",
      "howToManage": "Johtamisvinkit",
      "watchOut": "HUOMIOI"
    },
    "verifiedByAon": "Vahvistettu AON:n verkkoarvioinneilla",
    "orSignInWith": "Tai kirjaudu sisään",
    "invalidField": "Virheellinen kenttä",
    "comingSoonAlt": "sivu on rakenteilla ja tulossa pian",
    "employeeSizes": [
      "1-10",
      "11-50",
      "51-150",
      "151- 300",
      "300-1000",
      "1001+"
    ]
  }
};

export default dictionary;
